import { HttpClient, RequestConfig } from "@planzone/services";
import { Dependencies } from "@planzone/core";

function createTokenProvider(session: Dependencies["session"]) {
  return (httpClient: HttpClient): HttpClient => ({
    sendHttpRequest<Response>(config: RequestConfig): Promise<Response> {
      return new Promise<Response>((resolve, reject) =>
        session
          .retrieve()
          .then(({ accessToken }) =>
            httpClient
              .sendHttpRequest<Response>({
                ...config,
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                  ...config.headers,
                },
              })
              .then(resolve)
              .catch(reject),
          )
          .catch(() =>
            httpClient
              .sendHttpRequest<Response>(config)
              .then(resolve)
              .catch(reject),
          ),
      );
    },
  });
}

export { createTokenProvider };
